import { combineReducers } from '@reduxjs/toolkit';

import advertCategoriesReducer from './advertCategoriesSlice';
import ageGatedTermsReducer from './ageGatedCategoriesTerms';
import advertsReducer from './advertsSlice';
import advertsGatedReducer from './advertsGatedSlice';
import appReducer from './appSlice';
import buildingSelectionReducer from './buildingSelectionSlice';
import newsReducer from './newsSlice';
import galleryReducer from './gallerySlice';
import contestReducer from './contestSlice';
import pushNotificationReducer from './pushNotificationSlice';
import propertyManagerReducer from './propertyManagerSlice';

import AsyncStorage from '@react-native-async-storage/async-storage';
import { persistReducer } from 'redux-persist';

const appConfig = {
  key: 'app',
  storage: AsyncStorage,
  blacklist: ['isLoading', 'isShowModal'],
};

const rootReducer = combineReducers({
  advertCategories: advertCategoriesReducer,
  ageGatedTerms: ageGatedTermsReducer,
  adverts: advertsReducer,
  advertsGated: advertsGatedReducer,
  app: persistReducer(appConfig, appReducer), // this is persisted to local storage
  buildingSelection: buildingSelectionReducer,
  news: newsReducer,
  gallery: galleryReducer,
  contest: contestReducer,
  propertyManager: propertyManagerReducer,
  pushNotification: pushNotificationReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
